import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';

const HeaderFlyoutItem = ({
  children,
  href,
  onClick,
  title,
  isDropdown,
  icon,
  target,
  className,
}) => <li className={cn('c-header-nav__item', className)}>
    <Button
      className="c-header-nav__link"
      color="none"
      href={href}
      onClick={onClick}
      target={target}
    >
      <span className="c-header-nav__text">{title || children}</span>
      {icon && (
        <Icon
          icon={icon}
          className="c-header-nav__icon  c-header-nav__icon--right"
        />
      )}
      {isDropdown && (
        <Icon
          icon="arrow-right"
          className="c-header-nav__icon  c-header-nav__icon--right"
        />
      )}
    </Button>
    {title ? children : null}
  </li>

export default HeaderFlyoutItem;

HeaderFlyoutItem.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
};

HeaderFlyoutItem.defaultProps = {
  href: '',
  onClick: null,
  icon: null,
};
